var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var progressBar = reset;
export var inline = __assign(__assign({}, progressBar), { alignItems: 'center', borderRadius: 16, display: 'flex' });
export var barWrapper = {
    background: 'transparent',
    borderRadius: 16,
    display: 'flex',
    flexGrow: 1,
    height: 24,
    position: 'relative',
};
export var barWrapperBackground = __assign(__assign({}, barWrapper), { background: '#DFE4E8', overflow: 'hidden' });
export var small = {
    height: 12,
};
export var large = {
    height: 24,
};
export var bar = {
    borderRadius: 0,
    display: 'block',
    position: 'absolute',
    height: '100%',
    background: '#1CACB8',
    color: '#ffffff',
};
export var informational = __assign(__assign({}, bar), { background: '#24AAB2', borderRight: "1px solid ".concat('#ffffff'), boxSizing: 'border-box' });
export var warning = __assign(__assign({}, bar), { background: '#FFB900', borderRight: "1px solid ".concat('#ffffff'), boxSizing: 'border-box' });
export var complete = __assign(__assign({}, bar), { background: '#0D850D' });
export var data = __assign(__assign({}, bar), { background: '#0D850D' });
export var segmentBarWrapper = {
    background: 'transparent',
    position: 'relative',
};
export var segmentWrapper = {
    display: 'inline-block',
    margin: "".concat(4, "px 0 ").concat(4, "px 0"),
};
export var segmentBlock = {
    boxSizing: 'border-box',
    height: 24,
    borderLeft: "2px solid transparent",
    borderRight: "2px solid transparent",
    borderRadius: 16,
    backgroundClip: 'padding-box', // needed for transparent border
};
export var segmentPointer = {
    borderLeft: "1px solid #666666",
    height: 8,
    margin: '2px 0 0 10px',
    width: 12,
};
export var segmentLabel = {
    color: '#323E48',
    fontSize: 14,
    lineHeight: '150%',
    overflow: 'hidden',
    paddingRight: '4px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
export var segmentLegendWrapper = {
    display: 'inline-block',
};
export var segmentLegendTitle = {
    fontSize: 24,
    fontWeight: 700,
    fontVariantNumeric: 'slashed-zero lining-nums tabular-nums',
    lineHeight: '125%',
    leadingTrim: 'both',
    letterSpacing: '0.07rem',
    marginLeft: 4,
    textEdge: 'cap',
};
export var segmentLegendLabel = {
    color: '#323E48',
    fontSize: 14,
    fontWeight: '450',
    lineHeight: '150%',
    marginLeft: 4,
};
export var header = {
    color: '#000000',
    fontSize: "".concat(14, "px !important"),
    lineHeight: '125%',
    margin: "0 0 ".concat(4, "px ").concat(2, "px"),
};
export var headerLarge = {
    color: '#000000',
    fontSize: "24px !important",
    fontWeight: '625',
    lineHeight: '125%',
    margin: "0 0 ".concat(2, "px ").concat(2, "px"),
};
export var headerExtraLarge = {
    color: '#14222E',
    fontSize: "40px !important",
    fontWeight: 700,
    lineHeight: '125%',
    margin: "0 0 0 ".concat(2, "px"),
    fontVariantNumeric: 'lining-nums tabular-nums',
    leadingTrim: 'both',
    textEdge: 'cap',
};
export var headerInline = __assign(__assign({}, header), { display: 'flex', margin: "0 0 0 12px", minWidth: 24, overflow: 'hidden', whiteSpace: 'nowrap' });
export var headerInlineLarge = __assign(__assign({}, header), { display: 'flex', fontSize: "24px", fontWeight: '625', margin: "0 0 0 ".concat(16, "px"), minWidth: 34, overflow: 'hidden', whiteSpace: 'nowrap' });
export var footnote = {
    fontSize: "".concat(14, "px !important"),
    fontWeight: '550',
    lineHeight: '150%',
    textAlign: 'right',
    color: '#323E48',
};
export var step = {
    background: '#1CACB8',
    borderRadius: 0,
    display: 'block',
    height: '100%',
    position: 'absolute',
    transition: "width 300ms cubic-bezier(0.645, 0.045, 0.355, 1.000)",
};
export var stepProgress = __assign(__assign({}, bar), { background: '#1CACB8', transition: "width 300ms cubic-bezier(0.645, 0.045, 0.355, 1.000)" });
export var trendLargeWrapper = {
    margin: "0 0 0 ".concat(16, "px"),
};
export var trendSmallWrapper = {
    margin: "0 0 0 ".concat(8, "px"),
};
export var trendContent = {
    color: '#000000',
    margin: "0 0 0 6px",
};
export var trendLarge = __assign(__assign({}, trendContent), { fontSize: 14, fontWeight: 700, fontVariantNumeric: 'slashed-zero lining-nums tabular-nums', leadingTrim: 'both', letterSpacing: '0.07rem', textEdge: 'cap' });
export var trendSmall = __assign(__assign({}, trendContent), { fontSize: 14, fontWeight: 700 });
export var trendHeaderWrapper = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginBottom: '4px',
};
export var colorTypes = {
    blue: '#1454CC',
    blueDark: '#0038A3',
    green: '#0D850D',
    greenLighter: '#7DD17D',
    purple: '#6D12B2',
    purpleLighter: '#DEB2FF',
    orange: '#FE511F',
    orangeLighter: '#FEC3B2',
    yellow: '#FFB900',
    red: '#D6273D',
    pink: '#24AAB2',
    lime: '#1D941D',
    positive: '#0D850D',
    negative: '#D6273D',
    neutral: '#323E48',
};
export var colorLabelTypes = {
    blue: '#003FB8',
    blueDark: '#002E85',
    green: '#004700',
    greenLighter: '#007500',
    purple: '#480080',
    purpleLighter: '#5E00A6',
    orange: '#992200',
    orangeLighter: '#E53705',
    yellow: '#805D00',
    red: '#8F0012',
    pink: '#005157',
    lime: '#007500',
    positive: '#004700',
    negative: '#8F0012',
    neutral: '#000000',
};
